import { Component } from '@angular/core';
import { MovieService } from '../movie.service';
@Component({
  selector: 'app-movie-details',
  templateUrl: './movie-details.component.html',
  styleUrls: ['./movie-details.component.scss']
})
export class MovieDetailsComponent {
Trending :any;

constructor(public ms: MovieService){
}
 
ngOnInit():void{
  let data = this.ms.getTrendingData();
  if(data){
    this.Trending =JSON.parse( data);
  }
  console.log(this.Trending)
}

onEdit(Trend:any){
  
}
}
